import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';
import { Tooltip } from '../..';

export interface MarkupExceptionProps {
  variable: string;
  value: string;
  isEmphasizedPolicyResult: boolean;
}

const MarkupException: FunctionComponent<MarkupExceptionProps> = ({
  variable,
  value,
  isEmphasizedPolicyResult,
}: MarkupExceptionProps) => {
  const parent = (
    <Text
      variant={isEmphasizedPolicyResult ? 'hoverableBold.error' : 'hoverable.error'}
      sx={{ display: 'inline', whiteSpace: 'pre' }}
    >
      {variable}
    </Text>
  );
  return (
    <Tooltip
      position="top"
      arrow="center"
      parent={parent}
    >
      {value && value.toString()}
    </Tooltip>
  );
};

export default MarkupException;
